import { Box } from '@/components/box';

interface AnimatedArrowProps {
  isActive: boolean;
  side: 'left' | 'right';
}

export function AnimatedArrow({ isActive, side }: AnimatedArrowProps) {
  const maskXLeft = side === 'left' ? '0' : '50%';
  const maskXRight = side === 'left' ? '50%' : '100%';

  return (
    <Box
      css={{
        $$rightDelay: side === 'left' ? '0s' : '0.25s',
        $$activeDelay: isActive ? '0s' : '0.25s',
        $$delay: `calc($$rightDelay + $$activeDelay)`,
        $$duration: `calc(0.75s - $$rightDelay)`,
        position: 'absolute',
        bottom: isActive ? 10 : 0,
        right: 0,
        width: '100%',
        height: '1.25rem',
        transform: 'translate(0, 50%)',
        color: '$foreground',
        pointerEvents: 'none',
        clipPath: isActive
          ? `polygon(${maskXLeft} 100%, ${maskXRight} 100%, ${maskXRight} 100%, ${maskXLeft} 100%)`
          : `polygon(${maskXLeft} 0, ${maskXRight} 0, ${maskXRight} 100%, ${maskXLeft} 100%)`,
        transition: 'clip-path $$duration $$delay',
        transitionTimingFunction: 'ease-out',
        '.phase-item:hover &': {
          $$activeDelay: isActive ? '0.25s' : '0s',
          clipPath: isActive
            ? `polygon(${maskXLeft} 0, ${maskXRight} 0, ${maskXRight} 100%, ${maskXLeft} 100%)`
            : `polygon(${maskXLeft} 0, ${maskXRight} 0, ${maskXRight} 0, ${maskXLeft} 0)`,
        },
      }}
    >
      <Box
        css={{
          position: 'absolute',
          top: '50%',
          left: 0,
          width: 'calc(100% - 3px)',
          transform: 'translate(0%, -50%)',
          height: 3,
          background: '$foreground',
        }}
      />
      <Box
        css={{
          position: 'absolute',
          right: 3,
          top: '50%',
          width: '1rem',
          aspectRatio: '1 / 1',
          transform: 'translate(0%, -50%) rotate(45deg)',
          border: '3px solid $foreground',
          borderBottomWidth: 0,
          borderLeftWidth: 0,
        }}
      />
    </Box>
  );
}
